import React, { useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

import { GET, POST, PUT } from "../../api/requests";
import ShipmentTag from "../../components/ShipmentTag";

const platforms = {
  PORTPRO: {
    name: "PortPro",
    platformName: "PORTPRO",
    logo: "./logos/portpro.png",
    description: "Transport management",
  },
  AXLE: {
    name: "Axle / PortPro",
    platformName: "AXLE",
    logo: "./logos/portpro.png",
    description: "Transport management",
  },
  FLEXPORT: {
    name: "Transmission",
    platformName: "FLEXPORT",
    logo: "./logos/transmission.png",
    description: "Freight forwarding portal",
  },
  E2OPEN: {
    name: "E2Open",
    platformName: "E2OPEN",
    logo: "./logos/e2open.png",
    description: "Supply chain management",
  },
};

export default function Credentials() {
  const navigate = useNavigate();

  const [credentials, setCredentials] = useState([]);

  useQuery(
    ["credentials"],
    async () => {
      const response = await GET(`/credentials`);
      return response; // Return the entire response
    },
    {
      onSuccess: (data) => {
        console.log({ data });
        if (data) setCredentials(data);
      },
    }
  );

  return (
    <>
      <div className="space-y-2">
        <div className="mx-auto space-y-2 max-w-5xl px-4 py-6 sm:px-12 lg:px-12">
          {credentials.map((credential) => (
            <div
              id={`activity:${credential.id}`}
              className="rounded-xl mx-auto shadow-lg shadow-gray-50 shadow-opacity-20 border border-gray-200 bg-white pt-3 max-w-[80%]"
            >
              <div className="justify-between flex items-center pl-3 pr-3 space-x-2 text-sm text-gray-800">
                <div className="flex items-center w-full justify-between">
                  <div className="flex items-center w-full">
                    <ShipmentTag
                      shipment={{
                        container: credential.platform,
                        shipper: credential.authType,
                      }}
                    />
                  </div>
                  <div className="flex items-center"></div>
                </div>
                <div
                  style={{ fontSize: 10 }}
                  className="ml-2 font-normal w-1/3 text-gray-500 flex items-center justify-end"
                >
                  <p className="truncate inline float-right mr-2">
                    {new Date(credential.created_at).toDateString()}
                  </p>
                </div>
              </div>

              <div className="snippets mt-3 border-t border-gray-200 overflow-hidden divide-gray-100 divide-y">
                <div className="flex items-center px-4 py-3 relative">
                  <div className="text-xs text-gray-700 font-medium flex-1 w-full items-center overflow-x-auto ">
                    <div className="flex items-center space-x-2 flex-nowrap">
                      <img
                        alt="platform logo"
                        className="rounded-md mr-2"
                        src={
                          credential.platform
                            ? platforms[credential.platform]?.logo
                            : ""
                        }
                        style={{ width: 20 }}
                      />
                      {`${credential.platform} ${credential.authType} credential for ${credential.tenant}`}
                    </div>
                  </div>

                  <div className="flex items-center ml-3">
                    <button
                      onClick={() =>
                        navigate(`/credentials/${credential.id}/manage`)
                      }
                      style={{
                        backgroundColor: "#C2FB20",
                        color: "#0F172A",
                      }}
                      className=" py-1.5 flex hover:bg-opacity-70 items-center space-x-1.5 font-medium text-xs px-2.5 rounded-md"
                    >
                      <p>Manage credential</p>
                    </button>
                  </div>
                </div>

                <div className="border-t text-gray-500 py-2 text-xs px-4 flex items-center justify-between w-full">
                  <div className="flex items-center space-x-2">
                    {platforms[credential.platform]?.description ||
                      "No description"}
                  </div>
                  <div className="flex items-center space-x-2">
                    <div style={{ fontSize: 10 }} className="text-gray-400">
                      Created at{" "}
                      {new Date(credential.created_at).toLocaleTimeString()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
